module.exports = {
  'en': {
    'HRES89UC1': {
      '0': '[HRES89U] Approve Of Staff Requsition',
      '10': '[HRES89U] Approve Of Staff Requsition',
      '20': 'No.',
      '30': 'Req. Date',
      '40': 'Department',
      '50': 'Position',
      '60': 'Requested By',
      '70': 'Status',
      '80': 'Approved By',
      '90': 'Appr. Date',
      '100': 'Remark',
      '110': 'Next Approve',
      '120': 'Employee code',
      '130': 'Employee name',
      '140': 'Page',
      '150': 'Req. No.'
    },
    'HRES89UC2': {
      '0': 'Detail of Approve',
      '10': 'Request Date',
      '20': 'Request By',
      '30': 'For Department',
      '40': 'For Position',
      '50': 'Recruiter I.d',
      '60': 'Start Date for application',
      '70': 'Close Date',
      '80': 'Detail of Approve',
      '90': 'Seq. no.',
      '100': 'Approved By',
      '110': 'Date',
      '120': 'Current Status of Approve ',
      '130': 'Approved Status',
      '140': 'Approved',
      '150': 'Refused',
      '160': 'Remark'
    },
    'HRES89UC3': {
      '0': 'Details of Request',
      '10': 'Details of Request',
      '20': 'Approved By',
      '30': 'Req. Date',
      '40': 'For Department',
      '50': 'Position',
      '60': 'Per.Req.No.',
      '70': 'Job Description',
      '80': 'No. of Emp. Req.',
      '90': 'Type of Employment',
      '100': 'Req.Date',
      '110': 'Employment Period',
      '120': 'Yrs.',
      '130': 'Month',
      '140': 'Salary',
      '150': 'Baht',
      '160': 'Reason of Request',
      '170': 'Recuit From',
      '180': 'Internal',
      '190': 'External',
      '200': 'Remark',
      '210': 'Qualification Requirement',
      '220': 'By Job Spec.',
      '230': 'New Criteria'
    }
  },
  'th': {
    'HRES89UC1': {
      '0': '[HRES89U] อนุมัติคำร้องขอจ้างงาน',
      '10': '[HRES89U] อนุมัติคำร้องขอจ้างงาน',
      '20': 'ลำดับที่',
      '30': 'วันที่ขอ',
      '40': 'หน่วยงาน',
      '50': 'ตำแหน่ง',
      '60': 'ขออนุมัติโดย',
      '70': 'สถานะ',
      '80': 'ผู้อนุมัติ',
      '90': 'วันที่อนุมัติ',
      '100': 'หมายเหตุการอนุมัติ',
      '110': 'ผู้อนุมัติลำดับถัดไป',
      '120': 'รหัสพนักงาน',
      '130': 'ชื่อ - นามสกุล',
      '140': 'หน้า',
      '150': 'ลำดับคำร้อง'
    },
    'HRES89UC2': {
      '0': 'รายละเอียดการอนุมัติ',
      '10': 'วันที่ขออนุมัติ',
      '20': 'ขออนุมัติโดย',
      '30': 'สำหรับหน่วยงาน',
      '40': 'สำหรับตำแหน่ง',
      '50': 'รหัสผู้รับสมัคร',
      '60': 'วันที่เปิดรับสมัคร',
      '70': 'วันที่ปิดรับสมัคร',
      '80': 'รายละเอียดการอนุมัติ',
      '90': 'ลำดับที่อนุมัติ',
      '100': 'อนุมัติโดย',
      '110': 'วันที่',
      '120': 'สถานะปัจจุบัน',
      '130': 'สถานะการอนุมัติ',
      '140': 'อนุมัติ',
      '150': 'ไม่อนุมัติ',
      '160': 'หมายเหตุ'
    },
    'HRES89UC3': {
      '0': 'รายละเอียดการขออนุมัติ',
      '10': 'รายละเอียดการขออนุมัติ',
      '20': 'ผู้อนุมัติ',
      '30': 'วันที่ขอ',
      '40': 'สำหรับหน่วยงาน',
      '50': 'ตำแหน่ง',
      '60': 'เลขที่ใบขออนุมัติ',
      '70': 'ลักษณะงาน',
      '80': 'จำนวนที่ขอ',
      '90': 'ประเภทการจ้างงาน',
      '100': 'วันที่ที่ต้องการ',
      '110': 'กำหนดการจ้างงาน',
      '120': 'ปี',
      '130': 'เดือน',
      '140': 'เงินเดือน',
      '150': 'บาท',
      '160': 'สาเหตุการขอ',
      '170': 'ขอจาก',
      '180': 'ภายใน',
      '190': 'ภายนอก',
      '200': 'หมายเหตุ',
      '210': 'คุณสมบัติที่ต้องการ',
      '220': 'ตามที่ระบุในลักษณะงาน',
      '230': 'กำหนดขึ้นใหม่'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres89u.js